export const FETCH_QUOTE = 'quotes/FETCH_QUOTE';
export const CREATE_QUOTE = 'quotes/CREATE_QUOTE';
export const CLEAR_QUOTE = 'quotes/CLEAR_QUOTE';
export const FETCH_CURRENCIES = 'quotes/FETCH_CURRENCIES';
export const FETCH_LOCATIONS = 'quotes/FETCH_LOCATIONS';
export const SET_CURRENCY = 'quotes/SET_CURRENCY';
export const CREATE_VEHICLE = 'quotes/CREATE_VEHICLE';
export const UPDATE_VEHICLE = 'quotes/UPDATE_VEHICLE';
export const DELETE_VEHICLE = 'quotes/DELETE_VEHICLE';
export const FETCH_VEHICLE = 'quotes/FETCH_VEHICLE';
export const FETCH_VEHICLES = 'quotes/FETCH_VEHICLES';
export const CLEAR_VEHICLES = 'quotes/CLEAR_VEHICLES';
export const FETCH_VEHICLE_INSURANCE_OPTIONS = 'quotes/FETCH_VEHICLE_INSURANCE_OPTIONS';
export const CREATE_VEHICLE_INSURANCE_OPTION = 'quotes/CREATE_VEHICLE_INSURANCE_OPTION';
export const UPDATE_VEHICLE_INSURANCE_OPTION = 'quotes/UPDATE_VEHICLE_INSURANCE_OPTION';
export const DELETE_VEHICLE_INSURANCE_OPTION = 'quotes/DELETE_VEHICLE_INSURANCE_OPTION';
export const CREATE_EXTRA = 'quotes/CREATE_EXTRA';
export const UPDATE_EXTRA = 'quotes/UPDATE_EXTRA';
export const DELETE_EXTRA = 'quotes/DELETE_EXTRA';
export const FETCH_EXTRAS = 'quotes/FETCH_EXTRAS';
export const UPDATE_DONATION = 'quotes/UPDATE_DONATION';
export const FETCH_TOTALS = 'quotes/FETCH_TOTALS';
export const FETCH_DONATIONS = 'quotes/FETCH_DONATIONS';
export const CREATE_CUSTOMER = 'quotes/CREATE_CUSTOMER';
export const UPDATE_CUSTOMER = 'quotes/UPDATE_CUSTOMER';
export const SET_CUSTOMER_STATE = 'quotes/SET_CUSTOMER_STATE';
export const SET_PICKUP_DATE = 'quotes/SET_PICKUP_DATE';
export const SET_PICKUP_TIME = 'quotes/SET_PICKUP_TIME';
export const SET_DROPOFF_DATE = 'quotes/SET_DROPOFF_DATE';
export const SET_DROPOFF_TIME = 'quotes/SET_DROPOFF_TIME';
export const SET_PICKUP_LOCATION = 'quotes/SET_PICKUP_LOCATION';
export const SET_DROPOFF_LOCATION = 'quotes/SET_DROPOFF_LOCATION';
export const CREATE_BOOKING = 'quotes/CREATE_BOOKING';
export const TOGGLE_PREMIUM_VEHICLE_UPGRADE = 'quotes/TOGGLE_PREMIUM_VEHICLE_UPGRADE';
export const SET_SELECTED_VEHICLE_TYPE = 'quotes/SET_SELECTED_VEHICLE_TYPE';


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/quotes/mutation-types.js